import { Box, Tooltip } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import StarIcon from "@mui/icons-material/Star";
import {
  USERNAME_BADGE_SUPPORTER_COLOR,
  USERNAME_BADGE_SUPPORTER_LABEL,
  USERNAME_BADGE_VERIFIED_LABEL,
  normalizeUsernameBadges,
} from "../utils/usernameBadges";

const iconWrapSx = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  lineHeight: 1,
  flexShrink: 0,
};

function BadgeIcon({ title, color, children }) {
  return (
    <Tooltip title={title} arrow enterDelay={300}>
      <Box component="span" aria-label={title} sx={{ ...iconWrapSx, color }}>
        {children}
      </Box>
    </Tooltip>
  );
}

export default function UsernameBadges({
  verified = false,
  supporter = false,
  badges,
  sx = {},
}) {
  const flags = badges
    ? normalizeUsernameBadges(badges)
    : { verified: Boolean(verified), supporter: Boolean(supporter) };

  if (!flags.verified && !flags.supporter) return null;

  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.25,
        ml: 0.4,
        verticalAlign: "middle",
        ...sx,
      }}
    >
      {flags.verified ? (
        <BadgeIcon title={USERNAME_BADGE_VERIFIED_LABEL} color="success.main">
          <CheckIcon sx={{ fontSize: "0.95em" }} />
        </BadgeIcon>
      ) : null}
      {flags.supporter ? (
        <BadgeIcon title={USERNAME_BADGE_SUPPORTER_LABEL} color={USERNAME_BADGE_SUPPORTER_COLOR}>
          <StarIcon sx={{ fontSize: "0.9em" }} />
        </BadgeIcon>
      ) : null}
    </Box>
  );
}
